module.exports = __webpack_public_path__ + "static/img/7.7fd2dfd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/sp/7.png
// module id = HRTy
// module chunks = 0